import { render } from "./EditReference.vue?vue&type=template&id=d2949c24&scoped=true"
import script from "./EditReference.vue?vue&type=script&lang=js"
export * from "./EditReference.vue?vue&type=script&lang=js"

import "./EditReference.vue?vue&type=style&index=0&id=d2949c24&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2949c24"]])

export default __exports__